import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "thoratech_cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let hasChoice = false;
    try {
      hasChoice = !!window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      hasChoice = false;
    }
    if (!hasChoice) {
      const t = setTimeout(() => setOpen(true), 800);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  const decide = (value) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ value, ts: new Date().toISOString() })
      );
    } catch (e) {
      /* ignore */
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-24 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] bg-[#01080E] text-white shadow-2xl border border-white/10"
    >
      <div className="relative p-5 md:p-6">
        <button
          aria-label="Dismiss"
          data-testid="cookie-dismiss"
          onClick={() => decide("dismissed")}
          className="absolute top-3 right-3 text-white/50 hover:text-white transition-colors"
        >
          <X size={16} />
        </button>
        <div className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#7BDCB5]">
          / Cookies
        </div>
        <p className="mt-3 text-sm leading-relaxed text-white/85">
          We use a small number of cookies to keep this site running and to understand how it is
          used. You can accept all or reject the non-essential ones. Read our{" "}
          <Link
            to="/privacy"
            data-testid="cookie-privacy-link"
            className="text-[#2AC0A5] hover:underline"
          >
            Privacy Policy
          </Link>
          .
        </p>
        <div className="mt-5 flex flex-wrap items-center gap-3">
          <button
            data-testid="cookie-accept"
            onClick={() => decide("accepted")}
            className="inline-flex items-center bg-[#2AC0A5] text-[#01080E] font-semibold px-4 py-2.5 text-sm hover:bg-white transition-colors"
          >
            Accept all
          </button>
          <button
            data-testid="cookie-reject"
            onClick={() => decide("rejected")}
            className="inline-flex items-center border border-white/20 text-white font-medium px-4 py-2.5 text-sm hover:border-[#2AC0A5] hover:text-[#2AC0A5] transition-colors"
          >
            Reject non-essential
          </button>
        </div>
      </div>
    </div>
  );
}
